var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.displayMap.showLogIn(_vm.authnState))?_c('Login'):(_vm.displayMap.showRequireNewPassword(_vm.authnState))?_c('RequireNewPassword'):(_vm.displayMap.showForgotPassword(_vm.authnState))?_c('ForgotPassword'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }